export default __webpack_public_path__ + "static/media/2783.38d11272.png";